import { Component, OnInit } from '@angular/core';
import {Router} from '@angular/router';
import {NotifierService} from 'angular-notifier';
import {MessageService} from '../message.service';
import {RestApiService} from '../rest-api.service';
import {Formatters} from 'angular-slickgrid';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {Subscription} from 'rxjs';


@Component({
  selector: 'app-escalation-workflow',
  templateUrl: './escalation-workflow.component.html',
  styleUrls: ['./escalation-workflow.component.css']
})
export class EscalationWorkflowComponent implements OnInit {
	private notifier: NotifierService;
	ttypes = [];
    isError = false;
    typeChecked: number;
    isSolprovide: string;
    nextOffset: number;
    previousOffset: number;
    pageSize: number;
    page_no: number;
    totalPage: number;
    displayData: any;
    private clientId: number;
    respObject: any;
    categories = [];
    categorySelected: number;
    statusSelected: number;
    errorMessage: string;
    supportGroupSelected: number;
    type: string;
    offset: number;
    totalData: number;
    show: boolean;
    selected: number;
    groups = [];
    categoriyName: string;
    private baseFlag: any;
    private userAuth: Subscription;
    add = false;
    del = false;
    edit = false;
    view = false;
    workflows = [];
    supportGroupName: string;
    hideGroup: boolean;
    hidecategory: boolean
    solutionRadioArr = [];
    ticketType: string;
    selectSolutionRadio: any;
    selectSolutionRadio1: any;
    dataLoaded: boolean;
    escalate_status_seq = 7 ;
    reopen_status_seq = 26 ;
    status_sequence_action_id: number;
    solutionRadioArr1 = [];
    arr = [];
    ticketSelected: number;
    status: any;
    statusName: string;
    statusId: number;
  constructor(notifier: NotifierService, private modalService: NgbModal, private messageService: MessageService, private _rest: RestApiService) {
   this.notifier = notifier;
    this.messageService.getCellChangeData().subscribe(item => {
      switch (item.type) {
        case 'change':
          if (!this.messageService.edit) {
            this.notifier.notify('error', 'You do not have edit permission');
          } else {

          }
          break;
        case 'delete':
          if (!this.messageService.del) {
            this.notifier.notify('error', 'You do not have delete permission');
          } else {
            if (confirm('Are you sure?')) {
              this._rest.deleteEscalationWorkflow({id: item.id, user_id: this.messageService.getUserId()}).subscribe((res) => {
                this.respObject = res;
                if (this.respObject.success) {
                  // this.totalData = this.totalData - 1;
                  // this.messageService.setTotalData(this.totalData);
                  this.messageService.sendAfterDelete(item.id);
                } else {
                  this.notifier.notify('error', this.respObject.errorMessage);
                }
              }, (err) => {
                this.notifier.notify('error', this.respObject.errorMessage);
              });
            }
          }
          break;
      }
    });
   }

  ngOnInit() {
    this.dataLoaded = false;
    this.selectSolutionRadio = '';
    this.selectSolutionRadio1 = '';
    this.nextOffset = 0;
    this.previousOffset = 0;
    this.ticketSelected = 0;
    this.pageSize = this.messageService.pageSize;
    this.page_no = 0;
    this.totalPage = 0;
    this.hideGroup = true;
    this.displayData = {
      pageName: 'Maintain Esclate Workflow ',
      openModalButton: 'Esclation Workflow ',
      breadcrumb: 'Esclation Workflow',
      folderName: ' all Esclation Workflow',
      tabName: 'Esclation Workflow'
  };
    this.solutionRadioArr = [{'id': 1, 'name': 'Solution Provider'}, {'id': 2, 'name': 'Others'}];
    this.solutionRadioArr1 = [{'id': 1, 'name': 'All Categories'}, {'id': 2, 'name': 'Manual'}];
    this.status = [{'id': 0, 'name': 'select status'}, {'id': 1, 'name': 'Reopen'},{'id': 1, 'name': 'Escalate'}];



   const columnDefinitions = [
      {
        id: 'delete',
        field: 'id',
        excludeFromHeaderMenu: true,
        formatter: Formatters.deleteIcon,
        minWidth: 30,
        maxWidth: 30,
      },
      // {id: 'id', name: 'Id', field: 'id', sortable: true, filterable: true},
      {
        id: 'ttype', name: 'Ticket Type', field: 'ticketType', sortable: true, filterable: true
      },
      {
        id: 'category', name: 'Category', field: 'category', sortable: true, filterable: true
      },
      {
        id: 'group', name: 'Support Group', field: 'supportGroup', sortable: true, filterable: true
      },
      {
      	id: 'solutionGroup', name: 'Is solution Provide', field: 'isSolutionProvider', sortable: true, filterable: true
      },
      {
        id: 'status', name: 'Status Name', field: 'status_name', sortable: true, filterable: true
      },
    ];
     this.messageService.setColumnDefinitions(columnDefinitions);

    if (this.messageService.clientId) {
      this.clientId = this.messageService.clientId;
      this.baseFlag = this.messageService.baseFlag;
      this.onPageLoad();
    } else {
      this.userAuth = this.messageService.getClientUserAuth().subscribe(auth => {
        this.view = auth[0].viewFlag;
        this.add = auth[0].addFlag;
        this.edit = auth[0].editFlag;
        this.del = auth[0].deleteFlag;
        this.clientId = auth[0].clientId;
        this.baseFlag = auth[0].baseFlag;
        this.onPageLoad();
      });
    }
  }
    onPageLoad() {
        this._rest.getTicketType(this.clientId).subscribe((res1) => {
          this.respObject = res1;
          if (this.respObject.success) {
            this.typeChecked = this.respObject.details[0].id;
            this.type = this.respObject.details[0].name;
            this.ttypes = this.respObject.details;
            // this.isError = false;
            // this.respObject.details.unshift({id: 0, name: 'Select Ticket Type'});
            // this.ttypes = this.respObject.details;
            // this.ticketSelected = 0;
            this.getCategory();
          } else {
            this.notifier.notify('error', this.respObject.errorMessage);
          }
        }, (err) => {
          this.notifier.notify('error', this.messageService.SERVER_ERROR);
        });
    this.getTableData();
  }
   onButtonChange(value) {
    this.typeChecked = value.value;
    this.getCategory();
  }
   openModal(content) {
    if (!this.messageService.add) {
      this.notifier.notify('error', 'You do not have add permission');
    } else {
      this.isError = false;
      this.categorySelected = 0;
      this.statusSelected = 0;
      this.arr = [];
      this.supportGroupSelected = 0;
      this.ticketSelected = 0;
      this.modalService.open(content, {size: 'sm'}).result.then((result) => {
      }, (reason) => {
      });
    }
  }
   getCategory() {
    this._rest.getCategoryByTicketTypeNDynamicLevel(this.clientId, this.typeChecked).subscribe((res1) => {
      this.respObject = res1;
      if (this.respObject.success) {
        this.isError = false;
        this.respObject.details.unshift({id: 0, name: 'Select Category'});
        this.categories = this.respObject.details;
        this.categorySelected = 0;
      } else {
        this.isError = true;
        this.errorMessage = this.respObject.errorMessage;
      }
    }, (err) => {
      this.isError = true;
      this.errorMessage = this.messageService.SERVER_ERROR;
    });
  }
  getTableData() {
    if (!this.messageService.view) {
      this.notifier.notify('error', 'You do not have view permission');
    } else {
      this.getData({'offset': this.nextOffset, 'paginationType': ''});
    }
  }
   onPageSizeChange(value: any) {
    this.page_no = 0;
    this.nextOffset = 0;
    this.pageSize = value;
    this.getData({'offset': this.nextOffset, 'paginationType': ''});
  }
  getData(paginationObj) {
    const offset = paginationObj.offset;
    const paginationType = paginationObj.paginationType;
    this.dataLoaded = false;
    this._rest.getEscalationWorkflow(this.clientId, offset, this.pageSize, paginationType).subscribe((res) => {
      this.respObject = res;
      // console.log("responce"+ JSON.stringify(this.respObject));
      this.executeResponse(this.respObject, offset, paginationType);
    }, (err) => {
      this.notifier.notify('error', err);
    });
  }
  executeResponse(respObject, offset, paginationType) {
        if (respObject.success) {
            this.dataLoaded = true;
            if (offset === 0) {
                this.totalData = respObject.details.totalData[0].count;
                this.totalPage = respObject.details.totalPage;
                if (this.totalPage === 0) {
                    this.totalPage = 1;
                }
            }
            if (!this.isEmpty(respObject.details.dataObj)) {
                const data = respObject.details.dataObj;
                this.nextOffset = respObject.details.nextOffset;
                this.offset = respObject.details.nextOffset;
                this.previousOffset = respObject.details.previousOffset;
                this.messageService.setTotalData(this.totalData);
                this.messageService.setGridData(data);
                // ----------------------------------------------
                if (offset !== 0) {
                    const totalCount = this.totalData;
                    const divRes = totalCount / this.pageSize;
                    const remainder = totalCount % this.pageSize;
                    if (remainder === 0) {
                        this.totalPage = parseInt(String(divRes), 10);
                    } else {
                        this.totalPage = parseInt(String(divRes), 10) + 1;
                    }
                }
                // ------------------------------------------------
                if (paginationType === 'next') {
                    this.page_no = this.page_no + 1;
                } else if (paginationType === 'prev') {
                    this.page_no = this.page_no - 1;
                } else if (paginationType === '' && this.page_no === 0) {
                    this.page_no = this.page_no + 1;
                }
                if (this.totalData <= this.pageSize * this.page_no) {
                    this.nextOffset = 0;
                }
            } else if (this.isEmpty(respObject.details.dataObj) && paginationType === 'next') {
                this.nextOffset = 0;
            } else if (this.isEmpty(respObject.details.dataObj) && paginationType === 'prev') {
                this.previousOffset = 0;
            } else if (paginationType === '' && this.page_no === 0) {
                this.page_no = this.page_no + 1;
            }
        } else {
            this.notifier.notify('error', respObject.errorMessage);
        }
    }
    isEmpty(obj) {
    for (const key in obj) {
      if (obj.hasOwnProperty(key)) {
        return false;
      }
    }
    return true;
  }
  changeRouting(path: string) {
    this.messageService.changeRouting(path);
  }
  onCategoryChange(selectedIndex) {
    this.categoriyName = this.categories[selectedIndex].name;
      this._rest.getSupportGroupByCategory(this.clientId, this.categorySelected).subscribe((res1) => {
          this.respObject = res1;
          if (this.respObject.success) {
              this.isError = false;
              this.respObject.details.unshift({id: 0, name: 'Select Support Group'});
              this.groups = this.respObject.details;
              this.supportGroupSelected = 0;
          } else {
              this.isError = true;
              this.errorMessage = this.respObject.errorMessage;
          }
      }, (err) => {
          this.isError = true;
          this.errorMessage = this.messageService.SERVER_ERROR;
      });
  }

    onSolutionRadioChange(groupRadio) {
        if (groupRadio.value === 1) {
            this.hideGroup = true;
            this.isSolprovide = 'true';
        } else {
            this.hideGroup = false;
            this.isSolprovide = 'false';
        }
    }
  onstatusChange(selectedIndex: any){
    this.statusName = this.status[selectedIndex].name;
    this.statusId = this.status[selectedIndex].id ;
  }
  onGroupChange(selectedIndex: any) {
    this.supportGroupName = this.groups[selectedIndex].name;
  }

  save() {
    const data = {
      clientId: this.clientId,
      ticketTypeId: this.typeChecked,
      isSolutionProvider: this.isSolprovide,
      categoryId: this.categorySelected,
      statusName: this.statusName,
      createdBy: this.messageService.getUserId()
    };
      if (this.isSolprovide === 'false') {
          data['supportGroupLevelId'] = this.supportGroupSelected;
      }
      if (this.statusName === 'Reopen') {
        data['status_sequence_action_id'] =  this.reopen_status_seq ;

      } else if (this.statusName === 'Escalate') {
        data['status_sequence_action_id'] =  this.escalate_status_seq ;
      }
      console.log('data===' + JSON.stringify(data) + '=============' + this.statusId);
     if (!this.messageService.isBlankField(data) && this.statusId !== 0 ) {
      this._rest.insertEscalationWorkflow(data).subscribe((res) => {
        this.respObject = res;
        if (this.respObject.success) {
          this.isError = false;
            this.nextOffset = 0;
            this.previousOffset = 0;
            this.getTableData();
            this.categorySelected = 0;
            this.statusSelected =  0;
            this.supportGroupSelected = 0;
            this.isSolprovide = '';
            this.hideGroup = true;
            this.hidecategory = true;
            this.ticketSelected = 0;
            this.selectSolutionRadio = '';
            this.selectSolutionRadio1 = '';
        } else {
          this.isError = true;
          this.errorMessage = this.respObject.errorMessage;
        }
      }, (err) => {
        this.isError = true;
        this.errorMessage = err;
      });
    } else {
      this.isError = true;
      this.errorMessage = this.messageService.BLANK_ERROR_MESSAGE;
    }
  }
}
